export function validateRange(
	min: number | null | undefined,
	max: number | null | undefined,
	allowedMax: number,
	fieldName: string): string {

	if (min != null && min < 0) {
		return `min ${fieldName} cannot be negative`;
	}

	if (max != null && max < 0) {
		return `max ${fieldName} cannot be negative`;
	}

	if (min != null && min > allowedMax) {
		return `min ${fieldName} must be between 0 and ${allowedMax}`;
	}

	if (max != null && max > allowedMax) {
		return `max ${fieldName} must be between 0 and ${allowedMax}`;
	}

	if (min != null && max != null && min > max) {
		return `max ${fieldName} must be greater than or equal to min ${fieldName}`;
	}
	return '';
}


export function validateCity(city: string | null | undefined): string {

	if (!city) {
		return '';
	}

	const trimmedCity = city.trim();

	if (!trimmedCity) {
		return '';
	}

	if (!/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(trimmedCity)) {
		return 'City name can contain only letters and spaces';
	}

	return '';
}


export function sanitizeCity(city: string): string {
	return city
		.trim()
		.replace(/\s{2,}/g, ' ');
}